/**
 * Rewrites remote listing artwork through our own origin.
 *
 * Third-party image hosts set cookies (Cloudflare __cf_bm and friends) which
 * Lighthouse counts against Best Practices, so anything that is not already on
 * our own domain or in our storage bucket is served via /api/public/img.
 */
const SAME_ORIGIN_HOSTS = [/(^|\.)behot\.now$/i, /(^|\.)supabase\.co$/i, /(^|\.)lovable\.app$/i];

export function proxiedImage(src: string | null | undefined): string | undefined {
  if (!src) return undefined;
  if (src.startsWith("/") || src.startsWith("data:")) return src;
  let url: URL;
  try {
    url = new URL(src);
  } catch {
    return undefined;
  }
  if (url.protocol !== "https:") return undefined;
  // Mirrored artwork stored on our own origin: always serve it relative so the
  // preview/published build serves its own copy instead of hitting behot.now.
  if (url.pathname.startsWith("/api/public/img/s/")) return url.pathname;
  if (SAME_ORIGIN_HOSTS.some((re) => re.test(url.hostname))) return url.toString();
  return `/api/public/img/${encodeURIComponent(url.toString())}`;
}
